import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { VenturesPage } from './pages/VenturesPage';
import { ContactPage } from './pages/ContactPage';
import { RawfoundPropertiesPage } from './pages/RawfoundPropertiesPage';
import { ShoplinkyPage } from './pages/ShoplinkyPage';
import { AgentterPage } from './pages/AgentterPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-5">
      <Routes data-id="element-6">
        <Route path="/" element={<App data-id="element-8" />} data-id="element-7">
          <Route index element={<HomePage data-id="element-10" />} data-id="element-9" />
          <Route path="about" element={<AboutPage data-id="element-12" />} data-id="element-11" />
          <Route path="ventures" element={<VenturesPage data-id="element-14" />} data-id="element-13" />
          <Route path="contact" element={<ContactPage data-id="element-16" />} data-id="element-15" />
          <Route path="rawfound-properties" element={<RawfoundPropertiesPage data-id="element-18" />} data-id="element-17" />
          <Route path="shoplinky" element={<ShoplinkyPage data-id="element-20" />} data-id="element-19" />
          <Route path="agentter" element={<AgentterPage data-id="element-22" />} data-id="element-21" />
        </Route>
      </Routes>
    </BrowserRouter>;
}